// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-35e63116] .full-height {\n  position: relative;\n  height: 100%;\n}\n[data-v-35e63116] .el-dialog__body {\n  padding-top: 0px;\n}\n[data-v-35e63116] .networkcard-list .el-input.is-disabled .el-input__inner {\n  background-color: #fff6f694;\n  border-color: #1256d1;\n  color: #0137a3;\n  cursor: not-allowed;\n}\n[data-v-35e63116] .networkcard-list .el-input__suffix {\n  display: none;\n}\n[data-v-35e63116] :disabled {\n  color: blue !important;\n}\n", ""]);
// Exports
module.exports = exports;
